// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientsSearchPatientsRequestModel {
    static getAttributeTypeMap() {
        return PatientsSearchPatientsRequestModel.attributeTypeMap;
    }
}
PatientsSearchPatientsRequestModel.discriminator = undefined;
PatientsSearchPatientsRequestModel.additionalProperties = false;
PatientsSearchPatientsRequestModel.attributeTypeMap = [
    {
        "name": "maxRecordCount",
        "baseName": "maxRecordCount",
        "type": "number"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "Date"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "Gender"
    },
    {
        "name": "accountExternalIdType",
        "baseName": "accountExternalIdType",
        "type": "AccountExternalIdType"
    },
    {
        "name": "accountExternalId",
        "baseName": "accountExternalId",
        "type": "string"
    },
    {
        "name": "prescriberId",
        "baseName": "prescriberId",
        "type": "number"
    },
    {
        "name": "siteId",
        "baseName": "siteId",
        "type": "number"
    },
];
//# sourceMappingURL=patientsSearchPatientsRequestModel.js.map